module.exports = __webpack_public_path__ + "assets/img/slogan-24b3fad3.png";